'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var AutosavingInput = function (_Component) {
  _inherits(AutosavingInput, _Component);

  function AutosavingInput(props) {
    _classCallCheck(this, AutosavingInput);

    var _this = _possibleConstructorReturn(this, (AutosavingInput.__proto__ || Object.getPrototypeOf(AutosavingInput)).call(this, props));

    _this.blurOnEnterPress = function (e) {
      if (e.keyCode === 13) {
        _this.leaveEditingState(e);
      }
    };

    _this.leaveEditingState = function (_ref) {
      var _ref$target = _ref.target,
          name = _ref$target.name,
          value = _ref$target.value;

      if (_this.state.value === _this.props.initialValue) {
        return;
      } // Reset required field if user attempts to clear the value


      if (_this.props.required && !_this.state.value) {
        _this.setState({
          value: _this.props.initialValue || '',
          icon: null
        });

        return;
      }

      _this.setState({
        icon: 'cloudUp'
      });

      _this.props.onBlur(_defineProperty({}, name, value)).then(function () {
        _this.setState({
          icon: 'checkCircle'
        });

        _this.startResetTimer();
      }).catch(function () {
        _this.setState({
          icon: 'alert',
          value: _this.props.initialValue || ''
        });

        _this.startResetTimer();
      });
    };

    _this.startResetTimer = function () {
      return setTimeout(function () {
        return _this.setState({
          icon: null
        });
      }, _this.props.waitToHideIcon);
    };

    _this.state = {
      value: props.initialValue,
      icon: null
    };
    return _this;
  }

  _createClass(AutosavingInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keypress', this.blurOnEnterPress);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.initialValue !== this.props.initialValue) {
        this.setState({
          value: nextProps.initialValue || ''
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_text2.default, {
        label: this.props.label,
        icon: this.state.icon,
        name: this.props.name,
        id: this.props.id,
        value: this.state.value || '',
        theme: 'classic',
        onBlur: this.leaveEditingState,
        onChange: function onChange(_ref2) {
          var target = _ref2.target;
          return _this2.setState(function () {
            return {
              value: target.value
            };
          });
        },
        required: this.props.required,
        requiredLabel: this.props.requiredLabel,
        placeholder: this.props.placeholder
      });
    }
  }]);

  return AutosavingInput;
}(_react.Component);

AutosavingInput.defaultProps = {
  onBlur: null,
  label: null,
  name: null,
  id: null,
  placeholder: null,
  initialValue: null,
  waitToHideIcon: 2000,
  requiredLabel: 'Required'
};
AutosavingInput.propTypes = {
  // Form label to be applied above input.
  label: _propTypes2.default.string.isRequired,
  // Unique name for the input.
  name: _propTypes2.default.string.isRequired,
  // Unique id for the input.
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  // PROMISE passed in which determines which icon shows (success or failure)
  onBlur: _propTypes2.default.func.isRequired,
  // Default input placeholder.
  placeholder: _propTypes2.default.string.isRequired,
  //  HTML required attribute.
  required: _propTypes2.default.bool,
  // Text label to appear if input is required
  requiredLabel: _propTypes2.default.string,
  // User's current value for input eg: their name
  initialValue: _propTypes2.default.string,
  // How long success or failure icon should show before being removed.
  waitToHideIcon: _propTypes2.default.number
};
exports.default = AutosavingInput;